export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0053.f9112792.webp";